import { Skeleton } from "@/components/ui/skeleton"

export function MasterDataMappingModuleSkeleton() {
  return (
    <div className="flex h-full min-h-0 w-full flex-col overflow-hidden bg-card">
      {/* Header */}
      <div className="mt-4 flex items-start justify-between px-6 pb-2">
        <div className="space-y-1.5">
          <Skeleton className="h-5 w-44" />
          <Skeleton className="h-3.5 w-56" />
        </div>
      </div>

      {/* Step cards */}
      <div className="flex items-center gap-2 px-6 py-1">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="flex items-center gap-2">
            {i > 0 && <Skeleton className="h-px w-7" />}
            <Skeleton className="h-[52px] w-56 rounded-lg" />
          </div>
        ))}
      </div>

      {/* Main panel */}
      <div className="min-h-0 flex-1 px-6 py-4">
        <div className="flex h-full overflow-hidden rounded-lg border">
          {/* Left: column list */}
          <div className="flex w-[42%] flex-col border-r">
            <div className="flex items-center justify-between border-b bg-grey1 px-4 py-3">
              <Skeleton className="h-3 w-28" />
              <Skeleton className="h-5 w-20 rounded-full" />
            </div>
            {Array.from({ length: 8 }).map((_, i) => (
              <div
                key={i}
                className="flex items-center gap-3 border-b px-3 py-2"
              >
                <Skeleton className="h-6 w-6 rounded-md" />
                <Skeleton className="h-3.5 flex-1" />
                <Skeleton className="h-8 w-[220px] rounded-md" />
                <Skeleton className="h-8 w-8 rounded-md" />
              </div>
            ))}
          </div>

          {/* Right: preview table */}
          <div className="flex flex-1 flex-col">
            <div className="flex items-center justify-between border-b px-4 py-3">
              <Skeleton className="h-3 w-36" />
              <Skeleton className="h-3 w-24" />
            </div>
            <div className="flex border-b px-3 py-2">
              {Array.from({ length: 5 }).map((_, i) => (
                <Skeleton key={i} className="mx-2 h-3 flex-1" />
              ))}
            </div>
            {Array.from({ length: 7 }).map((_, i) => (
              <div key={i} className="flex border-b px-3 py-2">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Skeleton key={j} className="mx-2 h-3 flex-1" />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
